'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _logout = require('./logout.component');

var _logout2 = _interopRequireDefault(_logout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logoutModule = _angular2.default.module('logout', [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $urlRouterProvider.otherwise('/');

  $stateProvider.state('logout', {
    url: '/logout',
    template: '<logout></logout>',
    authenticate: true
  });
}).component('logout', _logout2.default);

exports.default = logoutModule;


// WEBPACK FOOTER //
// ./client/app/components/logout/logout.js